import React, { useState } from 'react';
import { Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import About from './pages/About/About';
import Jobs from './pages/Jobs/Jobs';
import Contact from './pages/Contact/Contact';
import AboutEn from './pages/About_EN/AboutEn';
import './App.scss';

const App: React.FC = () => {
  const [path, setPath] = useState('');

  const getPath = (path: string) => {
    setPath(path);
  };

  return (
    <div className="App">
      <Header path={path} />
      <main>
        <Route path="/" exact component={() => <About getPath={getPath} />} />
        <Route
          path="/jobs"
          exact
          component={() => <Jobs getPath={getPath} />}
        />
        <Route
          path="/contact"
          exact
          component={() => <Contact getPath={getPath} />}
        />
        <Route
          path="/en"
          exact
          component={() => <AboutEn getPath={getPath} />}
        />
      </main>
      <Footer />
    </div>
  );
};

export default App;
